<template>
  <Modal class="image-modal" width="medium">
    <template #body>
      <div v-if="imageUrl" class="image-modal__image">
        <img src="@/assets/svg/Check.svg" class="check-icon" alt="" />
        <img ref="logoImg" alt="" :src="imageUrl" class="image-input__image" />
      </div>
      <div v-else class="image-modal__input" @click="openFileExplorer">
        <input
          ref="fileInput"
          type="file"
          @change="uploadImage($event.target.files[0])"
        />
        <div class="image-modal__input__content">
          <img src="@/assets/svg/upload.svg" alt="" />
          <p class="link">Importez une image</p>
        </div>
      </div>
      <a class="link" @click="removeImage">Supprimer l'image</a>
      <div class="image-modal__photos">
        <p>
          Ou choisissez une image parmi une sélection d'images libres de droit :
        </p>

        <div v-if="isLoading" class="slider__loader">
          <CircularLoader />
        </div>

        <img
          v-for="photo in photos"
          :key="photo.id"
          class="image-modal__photo"
          :src="photo.urls.thumb"
          @click="selectPhoto(photo)"
        />

        <span class="legende">
          Les photos proviennent de la base d’images Unsplash. Unsplash est une
          banque d'images gratuite, basée aux Etats-Unis, elle déposera des cookies
          Google Analytics sur les terminaux des visiteurs de votre site sans que
          ceux-ci puissent s’y opposer. L’utilisation de cette photo se fait donc
          sous votre entière responsabilité et est susceptible d’entraîner une
          non-conformité de votre site au Règlement Général sur la Protection des
          Données. Pour plus d’informations, rendez-vous sur les mentions légales.
        </span>
      </div>
    </template>
    <template #footer>
      <div v-if="!$v.image.fileSize">
        <p class="text text--2 text--not-available">
          <img src="@/assets/svg/Bad-Check.svg" alt="" />
          <br />
          Veuillez choisir une image de moins de 2mb
        </p>
      </div>
      <div class="image-modal__cta-container">
        <button
          class="button button--negative button--x-small"
          @click="$emit('cancel')"
        >
          Annuler
        </button>
        <button
          class="button button--x-small"
          @click="$emit('confirm', selectedImageUrl)"
        >
          Valider
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { api } from '@/lib/api';
import CircularLoader from '@/components/common/CircularLoader';

export default {
  components: { Modal, CircularLoader },

  data() {
    return {
      isLoading: true,
      photos: [],
      imageUrl: null,
      selectedImageUrl: null,
      apiURL: process.env.VUE_APP_API_URL,
      image: {
        size: 0,
      },
    };
  },

  async created() {
    const { data } = await api.get('/photos');

    this.photos = data['hydra:member'].slice(0, 15);
    this.isLoading = false;
  },

  methods: {
    openFileExplorer() {
      this.$refs.fileInput.click();
    },

    async uploadImage(file) {
      this.image = file;

      if (!this.$v.image.fileSize) {
        return;
      }

      const formData = new FormData();
      formData.append('file', file, this.imageName);

      const { data } = await api.post('/images', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      this.imageUrl = data.contentUrl;
      this.selectedImageUrl = data.contentUrl;
    },

    removeImage() {
      this.imageUrl = null;
      this.selectedImageUrl = null;
    },

    selectPhoto(photo) {
      this.imageUrl = photo.urls.thumb;
      this.selectedImageUrl = photo.urls.full;
    },
  },

  validations: {
    image: {
      fileSize: image => {
        return image.size < 2000000;
      },
    },
  },
};
</script>
